export const PAST_FILTER_STATUSES = {
  all: "all",
  starred: "starred",
  blocked: "blocked",
} as const;

export type PastFilterStatus = (typeof PAST_FILTER_STATUSES)[keyof typeof PAST_FILTER_STATUSES];

export const UPCOMING_FILTER_STATUSES = {
  all: "all",
  credentialsNeeded: "credentialsNeeded",
  new: "new",
} as const;

export type UpcomingFilterStatus =
  (typeof UPCOMING_FILTER_STATUSES)[keyof typeof UPCOMING_FILTER_STATUSES];

export const TABS = {
  past: "past",
  upcoming: "upcoming",
} as const;

export type TabValue = (typeof TABS)[keyof typeof TABS];

const I18N_SKIP_TAB_QUERY_PARAM = "tab";
export const TAB_QUERY_PARAM = I18N_SKIP_TAB_QUERY_PARAM;

export const PAST_DEFAULT_SORT = "-shifts.lastShift.start" as const;
export const UPCOMING_DEFAULT_SORT = "shifts.nextShift.start" as const;

export const PAGE_SIZE = 20;

// HH My Professionals loads a single page and filters/sorts client-side, so this
// doubles as the per-workplace cap. Set to the contract max; exceeding it would
// need real server-side pagination + search.
export const HOME_HEALTH_PROFESSIONALS_PAGE_SIZE = 100;

export const DEFAULT_TIME_ZONE = "America/Los_Angeles";

// Backend fieldset projection (facility name + `tmz`) for formatting dates in the
// workplace timezone. A technical API identifier, not user-facing copy.
const I18N_SKIP_FACILITY_TIMEZONE_PROJECTION = "name tmz";
export const FACILITY_TIMEZONE_PROJECTION = I18N_SKIP_FACILITY_TIMEZONE_PROJECTION;

// Client-side sort keys for the HH list, applied over the loaded page.
export const HOME_HEALTH_SORT_OPTIONS = {
  professionalAsc: "name",
  professionalDesc: "-name",
  lastVisitAsc: "lastVisitAt",
  lastVisitDesc: "-lastVisitAt",
  totalVisitsAsc: "totalVisits",
  totalVisitsDesc: "-totalVisits",
} as const;

export type HomeHealthSortOption =
  (typeof HOME_HEALTH_SORT_OPTIONS)[keyof typeof HOME_HEALTH_SORT_OPTIONS];

/** Default sort: newest logged visit first. */
export const HOME_HEALTH_DEFAULT_SORT: HomeHealthSortOption =
  HOME_HEALTH_SORT_OPTIONS.lastVisitDesc;
